/**
 * Identidad del entorno en el que se construyó este bundle.
 *
 * CRA hornea `process.env.REACT_APP_*` en tiempo de build, así que esto NO es una
 * consulta al servidor: es lo que valía la config var cuando corrió `npm run build`.
 * Por eso el valor por defecto es `unknown` y no `prod` — un build local sin marcar
 * no debe hacerse pasar por producción.
 *
 * El mismo `REACT_APP_ENV` gobierna el nombre y los iconos de la PWA instalada, que
 * se reescriben después del build en `scripts/apply-env-branding.js`. Si cambia el
 * nombre del entorno, hay que cambiarlo en los dos sitios.
 */
export const APP_ENV = process.env.REACT_APP_ENV || 'unknown';

export const IS_DEV_ENV = APP_ENV === 'dev';

/**
 * Ámbar de dev, frente al verde de marca. Es el mismo color en las tres apps: el
 * icono del lanzador Android (`ic_launcher_background` del flavor `dev`), el
 * `AppIcon-Dev` de iOS, esta barra superior y el `theme_color` del manifest.
 */
export const DEV_ACCENT = '#B3541E';

/** Verde de marca. Duplicado a propósito de `theme.js` para no importar el tema aquí. */
export const BRAND_GREEN = '#284B32';

/** Color de la barra superior: verde salvo en dev. */
export const APP_BAR_COLOR = IS_DEV_ENV ? DEV_ACCENT : BRAND_GREEN;
